import { ContainerModule } from "inversify";
import { SerializedScenario } from '@xlearn/common'
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import ScenarioQuestionComponent from "./scenario-question-component.vue";
import { ScenarioQuestionAnswerProtobufSerializer } from "./scenario-question-answer-protobuf-serializer";

export const scenarioQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(ScenarioQuestionComponent)
    .whenTargetNamed("scenario");

  bind(SerializationApi.StateSerializationPluginSymbol).to(ScenarioQuestionAnswerProtobufSerializer)

  const options = { ...Api.defaultQuestionOptions<SerializedScenario>(),
    isSelfEvaluated: true
  }

  bind<Api.QuestionOptions<SerializedScenario>>(Api.QuestionOptionsPluginSymbol)
    .toConstantValue(options)
    .whenTargetNamed('scenario')
});
